import { ProxyFileUploadResponse } from 'store/types/FileUploadTypes';
import {
  CommitteeCycleModel,
  CommitteeCycleVotes,
  NetsuiteBallotData,
  NetsuiteBallotLineData,
  StandardsBallotsData,
  StandardsBallotsResponse,
  StandardsBallotsVoteModel,
  StandardsBallotsVoteResponse,
} from 'store/types/StandardsBallot';
import { ProxyService } from './ProxyService';
import { conf, semiProxyBaseUrl } from 'config';

export class BallotsService {
  public static getStandardsCommitteeCycles(): Promise<StandardsBallotsData> {
    return ProxyService.unauthenticatedProxyRequest(
      semiProxyBaseUrl + conf.proxyEndpoints.semiNetSuiteAnonymous,
      'get',
      {
        script: conf.netSuite.standardsBallotsScriptId,
      },
      null
    ).then((response: StandardsBallotsResponse): Promise<StandardsBallotsData> => {
      // Group ballot line items in same committee cycle as ballots.
      const committeeCycles = response.ballotData.map((committeCycle: NetsuiteBallotData): CommitteeCycleModel => {
        // Find the ballot line committe cycle that matches this committee cycle
        const ballotLineCommitteeCycle = response.ballotLineData.find(
          (c: NetsuiteBallotLineData): boolean =>
            c.committee === committeCycle.committee && c.period === committeCycle.period
        );

        return {
          ...committeCycle,
          ballotLineData: ballotLineCommitteeCycle ? ballotLineCommitteeCycle.ballotLineData : [],
        };
      });

      const data: StandardsBallotsData = {
        committeeCycles: committeeCycles,
        votingAnnouncements: response.announcement,
      };

      return Promise.resolve(data);
    });
  }

  public static GetCommitteeCycleVotes(): Promise<CommitteeCycleVotes[]> {
    return ProxyService.proxyRequest(
      semiProxyBaseUrl + conf.proxyEndpoints.semiNetSuite,
      'get',
      {
        script: conf.netSuite.standardsBallotsVotesScriptId,
      },
      null
    ).then((res: StandardsBallotsVoteResponse): Promise<CommitteeCycleVotes[]> => {
      return Promise.resolve(res.data ? res.data : []);
    });
  }

  public static async SaveVotes(votes: StandardsBallotsVoteModel[]): Promise<void> {
    const fileUploadPromises: Array<Promise<string | undefined>> = [];

    const votePayload = votes.map((vote) => {
      const v: StandardsBallotsVoteModel = { ...vote };
      if (v.uploadedFile) {
        fileUploadPromises.push(
          ProxyService.proxyUploadFile(
            semiProxyBaseUrl + conf.proxyEndpoints.fileUpload,
            v.uploadedFile,
            v.ballotInternalId,
            v.lineItemInternalId
          ).then((res: ProxyFileUploadResponse): string => res.url)
        );
        v.fileName = v.uploadedFile.name;
        delete v.uploadedFile;
      } else {
        fileUploadPromises.push(Promise.resolve(v.fileURL));
      }
      return v;
    });

    const values = await Promise.all(fileUploadPromises);
    values.forEach((fileUrl: string | undefined, i: number) => {
      votePayload[i].fileURL = fileUrl?.replace(' ', '-');
    });
    const requestBody = {
      voteData: votePayload,
    };
    await ProxyService.proxyRequest(
      semiProxyBaseUrl + conf.proxyEndpoints.semiNetSuite,
      'post',
      { script: conf.netSuite.standardsBallotsVotesScriptId },
      requestBody
    );
  }
}
